import React from "react";
import { Link } from "react-router-dom";
import { Plus, Star, Heart } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useWishlist } from "@/context/WishlistContext";
import { toast } from "sonner";

const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const { isIn, toggle } = useWishlist();
  const saved = isIn(product.product_id);

  const onToggleWish = async (e) => {
    e.preventDefault();
    const res = await toggle(product.product_id);
    if (res?.needAuth) toast.info("Please sign in to save items");
    else if (res?.ok) toast.success(saved ? "Removed from wishlist" : "Saved to wishlist");
  };

  return (
    <div className="card-lift group rounded-2xl border border-[#E5E5E0] bg-white overflow-hidden" data-testid={`product-card-${product.product_id}`}>
      <Link to={`/product/${product.product_id}`} className="block">
        <div className="relative aspect-[4/3] overflow-hidden bg-[#F0EFEA]">
          <img
            src={product.image_url}
            alt={product.name}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <span className="absolute top-3 left-3 tick-label bg-white/90 px-2 py-1 rounded-full">
            {product.category}
          </span>
          <button
            onClick={onToggleWish}
            className={`absolute top-3 right-3 h-8 w-8 inline-flex items-center justify-center rounded-full transition-colors ${saved ? "bg-[#E07A5F] text-white" : "bg-white/90 text-[#2C3E2D] hover:bg-white"}`}
            aria-label="toggle-wishlist"
            data-testid={`wishlist-toggle-${product.product_id}`}
          >
            <Heart className={`h-4 w-4 ${saved ? "fill-white" : ""}`} strokeWidth={1.75} />
          </button>
        </div>
      </Link>
      <div className="p-4">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <Link to={`/product/${product.product_id}`} className="hover:underline underline-offset-2">
              <h3 className="font-heading font-medium text-[#2C3E2D] truncate">{product.name}</h3>
            </Link>
            <p className="text-xs text-[#6B7B6C] mt-1">{product.unit}</p>
          </div>
          <div className="flex items-center gap-1 text-xs text-[#2C3E2D]" data-testid={`product-rating-${product.product_id}`}>
            <Star className="h-3.5 w-3.5 fill-[#F2CC8F] text-[#F2CC8F]" />
            <span>{product.rating?.toFixed(1)}</span>
          </div>
        </div>
        <div className="mt-4 flex items-center justify-between">
          <div className="font-heading text-lg text-[#2C3E2D]" data-testid={`product-price-${product.product_id}`}>
            ₹{product.price.toFixed(0)}
          </div>
          <button
            onClick={(e) => { e.preventDefault(); addItem(product); }}
            className="inline-flex items-center gap-1 rounded-full bg-[#2C3E2D] text-[#F9F8F6] hover:bg-[#E07A5F] transition-colors px-3.5 py-2 text-xs font-medium"
            data-testid={`add-to-cart-${product.product_id}`}
          >
            <Plus className="h-3.5 w-3.5" /> Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
